import { connect } from 'react-redux';

import { getProjectZoneId, getUpdatingSegment } from '../../../reducers/analyticsApp';
import { setSegmentDateRange } from '../../../actions/segment';
import CompoundUpdateDateRangePicker from '../../../components/compound/update/DateRangePicker';

const mapStateToProps = (state) => ({
  value: getUpdatingSegment(state).dateRange,
  zoneId: getProjectZoneId(state),
});

const mapDispatchToProps = {
  onChange: setSegmentDateRange,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompoundUpdateDateRangePicker);
